<template>
  <div class="mr-3 signatures-container">
    <div class="signatures-sticky-container">
      <b-form-group class="mb-3">
        <b-form-input
          id="tourStep2"
          :placeholder=placeholder
          name="search"
          size="sm"
          v-model="search"
        />
      </b-form-group>
      <Signature
        v-for="signature in signaturesFiltered"
        :key="signature.id"
        :name="signature.name"
        class="mb-2"
        @click="$emit('input', signature)"
        @close="$emit('input', undefined)"
        :closable="closableSign || (signature.id === value.id)"
        :selected="signature.id === value.id"
        :positioned="signature.positioned"
      />
    </div>
  </div>
</template>

<script>

import Signature from '@/febos/global/pdf/components/Signature';

const hasPositionValue = (value) => {
  if (value === null) {
    return false;
  }
  if (value === undefined) {
    return false;
  }
  return true;
};
export default {
  components: {
    Signature
  },
  data() {
    return {
      search: ''
    };
  },
  computed: {
    signaturesFiltered() {
      return this.signatures
        .map((signatureMap) => ({
          ...signatureMap,
          positioned: (hasPositionValue(signatureMap.page)
            && hasPositionValue(signatureMap.x)
            && hasPositionValue(signatureMap.y)
          )
        }))
        .filter((signature) => (
        // TODO: ascentFolding, maybe with asciiFolding library;
          signature.name.toLowerCase().includes(this.search.toLowerCase())
        ));
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: 'Búsqueda'
    },
    signatures: {
      type: Array,
      required: true
    },
    closableSign: {
      type: Boolean
    }
  }
};

</script>

<style lang="scss" scoped>

@import '~@core/scss/base/bootstrap-extended/include';

.signatures-container {
  width: 150px;
  position: relative;
}

.signatures-sticky-container {
  position: sticky;
  top: 100px;
  overflow: auto;
}

</style>
